import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { IconComponent } from '../../../../../shared/components/icon/icon.component';
import { TESTIMONIALS_DATA } from '../../../../../shared/constants/login-display-users.constants';
import { IconName } from '../../../../../shared/enums/icon-enum';
import { Testimonial } from '../../../../../shared/interfaces/log-in.interface';

@Component({
  selector: 'app-user-display',
  imports: [IconComponent],
  templateUrl: './user-display.component.html',
  styleUrl: './user-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDisplayComponent {
  public userData = signal<Testimonial[]>(TESTIMONIALS_DATA);
  public iconName = IconName;

  public selectedUser = signal<number>(1);

  public selectedUserData = computed<Testimonial | null>(() => {
    const list = this.userData();
    const index = this.selectedUser() - 1;
    return list[index] ?? null;
  });

  public handlePaginationChange(direction: 'next' | 'prev'): void {
    const total = this.userData().length;
    if (total === 0) return;

    this.selectedUser.update((current) => {
      if (direction === 'next') {
        return Math.min(current + 1, total);
      }
      return Math.max(current - 1, 1);
    });
  }

  public getStarArray(score: number): number[] {
    return Array(score);
  }
}
